export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/paperStatistics/basicLine/query`,
                data
            });
        },
        /**
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/paperStatistics/basicLine/get?id=${data.id}`
            })
        },
        /**
         * @param data
         * @return {*}
         */
        save(data) {
            return http.json({
                url: `/paperStatistics/basicLine/save`,
                data
            })
        },
        /**
         * @param data
         * @return {*}
         */
        removeMerchants(data) {
            return http.json({
                url: `/paperStatistics/basicLine/delete?id=${data[0].id}`,
                data
            })
        },
        /**
         * @param data
         * @return {*}
         */
        list(data) {
            return http.json({
                url: `/paperStatistics/basicLine/list`,
                data
            })
        },







    };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/basicLine.js